import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LoadingState } from "@/components/design-system";

export function RequireAuth({ children }) {
  const { user, checking } = useAuth();
  const loc = useLocation();
  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#E8F1FF]">
        <LoadingState label="Checking your session…" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  return children;
}

export function RedirectIfAuthed({ children }) {
  const { user, checking } = useAuth();
  if (checking) return null;
  if (user) return <Navigate to="/app" replace />;
  return children;
}
